/*
PRZYKŁADOWA STRUKTURA HTML LABELA:
<div>
    <div class="more-text-title">
        TEN TEKST ZAWSZE BĘDZIE POKAZANY
    </div>

    <div class="more-text">
        TEN TEKST POKAZUJE SIĘ PO KLIKNIĘCIU PRZYCISKU
    </div>

    <div class="button-show-more" style="display: inline">
        PRZYCISK ZWINŃ / ROZWIŃ
    </div>
</div>
*/

const btns = document.querySelectorAll('.button-show-more');
let txt;

btns.forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    txt = {
      htmlElement: button.previousElementSibling,
      isShown: button.classList.contains('show'),
    };

    if (txt.htmlElement != null) {
      if (!txt.isShown) {
        button.innerHTML = '... [ zwiń ]';
        txt.htmlElement.style.display = 'inline';
        setTimeout(() => {
          txt.htmlElement.style.opacity = '1';
        }, 50);
      } else {
        button.innerHTML = '... [ rozwiń ]';
        txt.htmlElement.style.opacity = '0';
        setTimeout(() => {
          txt.htmlElement.style.display = 'none';
        }, 700);
      }
    }
    button.classList.toggle('show');
  });
});

/*
*   WERSJA MAGDY
* */

const buttonsShowMore = document.querySelectorAll('#button-show-more');
const buttonsShowLess = document.querySelectorAll('#button-show-less');
const shortAgreement = document.querySelectorAll('#short-agreement');
const allAgreements = document.querySelectorAll('#all-agreement');
const checkboxsCheckboxLong = document.querySelectorAll('.checkbox-checkbox-long');
const divLabelAgreements = document.querySelectorAll('.custom-control-label-checkbox-long');
const allDivAgreements = document.querySelectorAll('.div-all-checkbox_long');

buttonsShowMore.forEach((buttonShowMore, index) => {
  buttonShowMore.addEventListener('click', () => {
    buttonShowMore.classList.add('d-none');
    shortAgreement[`${index}`].classList.add('d-none');
    allAgreements[`${index}`].classList.remove('d-none');
    divLabelAgreements[`${index}`].classList.remove('alignItems');
    allDivAgreements[`${index}`].classList.remove('custom-checkbox');
    allDivAgreements[`${index}`].classList.add('div-all-checkbox_long_style');
  });
});

buttonsShowLess.forEach((buttonShowLess, index) => {
  buttonShowLess.addEventListener('click', () => {
    allAgreements[`${index}`].classList.add('d-none');
    buttonsShowMore[`${index}`].classList.remove('d-none');
    shortAgreement[`${index}`].classList.remove('d-none');
    divLabelAgreements[`${index}`].classList.add('alignItems');
    checkboxsCheckboxLong[`${index}`].classList.add('alignItems');
    allDivAgreements[`${index}`].classList.add('custom-checkbox');
    allDivAgreements[`${index}`].classList.remove('div-all-checkbox_long_style');
  });
});
